export var PlatformFnoDetailsMapper = function (response) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var platformFnoDetailsEntity = {
        process_flg: 0,
        accountcode: "",
        clientMailId: "",
        rmMailId: "",
        requestdate: "",
        id: 0,
        remarks: "",
    };
    if (response && response.data && ((_a = response.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        platformFnoDetailsEntity = {
            process_flg: (_b = response === null || response === void 0 ? void 0 : response.data[0]) === null || _b === void 0 ? void 0 : _b.process_flg,
            accountcode: (_c = response === null || response === void 0 ? void 0 : response.data[0]) === null || _c === void 0 ? void 0 : _c.accountcode,
            clientMailId: (_d = response === null || response === void 0 ? void 0 : response.data[0]) === null || _d === void 0 ? void 0 : _d.clientMailId,
            rmMailId: (_e = response === null || response === void 0 ? void 0 : response.data[0]) === null || _e === void 0 ? void 0 : _e.rmMailId,
            requestdate: (_f = response === null || response === void 0 ? void 0 : response.data[0]) === null || _f === void 0 ? void 0 : _f.requestdate,
            id: (_g = response === null || response === void 0 ? void 0 : response.data[0]) === null || _g === void 0 ? void 0 : _g.id,
            remarks: (_h = response === null || response === void 0 ? void 0 : response.data[0]) === null || _h === void 0 ? void 0 : _h.remarks,
        };
    }
    return platformFnoDetailsEntity;
};
